import {NodeType} from "prosemirror-model";
import {Command} from "prosemirror-state";
import {findWrapping} from "prosemirror-transform";
import {getParentInGroupPos} from "../utils/getParentInGroupPos";
import {liftListItemCommand} from "../module/commands/node/list";

export const setListTypeOrWrapInList = (
    listType: NodeType,
    attrs: { type: string }
): Command => (state, dispatch) => {
    const { $from, $to } = state.selection

    const range = $from.blockRange($to)

    if (!range) {
        return false
    }

    const parentPos = getParentInGroupPos(range.$from, 'list')

    if (parentPos !== undefined) {
        // already in list
        const $pos = state.doc.resolve(parentPos)

        const node = $pos.nodeAfter

        if (node && node.type === listType && node.attrs.type === attrs.type) {
            // toggle list markup if it was already set
            return liftListItemCommand(state, dispatch);
        }

        if (dispatch) {
            dispatch(
                state.tr.setNodeMarkup(
                    parentPos,
                    listType,
                    node ? { ...node.attrs, ...attrs } : attrs
                )
            )
        }

        return true
    } else {
        const wrapping = findWrapping(range, listType, attrs)

        if (!wrapping) {
            return false
        }

        if (dispatch) {
            dispatch(state.tr.wrap(range, wrapping).scrollIntoView())
        }

        return true
    }
}